export const SETTINGS_KEY = 'groqSettings';

export const DEFAULT_SETTINGS = {
  apiKey: '',
  model: 'meta-llama/llama-4-maverick-17b-128e-instruct',
  maxLength: '1024',
  temperature: '0.6',
  topP: '0.9',
  presencePenalty: '0.3',
  frequencyPenalty: '0.2',
  replacements: [],
};

export const fallbackModels = [
  'llama-3.3-70b-versatile',
  'deepseek-r1-distill-llama-70b',
  'meta-llama/llama-4-maverick-17b-128e-instruct',
  'meta-llama/llama-4-scout-17b-16e-instruct',
];
